module.exports = __webpack_public_path__ + "img/experience.27a2bb04.png";